"use client";

import { useSearchParams } from "next/navigation";

const STORAGE_KEY_PREFIX = "nimble_ff_";

const getStorageKey = (flag: string): string => `${STORAGE_KEY_PREFIX}${flag}`;

export const getClientFeatureFlag = (
  flag: string,
  storage: Storage,
  searchParams: URLSearchParams,
): boolean => {
  const key = getStorageKey(flag);

  if (searchParams.get("ff") === flag) {
    try {
      storage.setItem(key, "true");
    } catch {
      // Ignore storage errors
    }
    return true;
  }

  try {
    return storage.getItem(key) === "true";
  } catch {
    return false;
  }
};

export const useClientFeatureFlag = (flag: string): boolean => {
  const searchParams = useSearchParams();

  if (typeof window === "undefined") {
    return false;
  }

  return getClientFeatureFlag(flag, localStorage, searchParams);
};
